import { Action } from "redux";

export const IS_SOLD_POLL_SHOW = "IS_SOLD_POLL_SHOW";

export interface IsSoldPollShowAction extends Action {
    readonly type: typeof IS_SOLD_POLL_SHOW;
    readonly productId: number;
}

export const isSoldPollShow = (productId: number): IsSoldPollShowAction => ({
    type: IS_SOLD_POLL_SHOW,
    productId,
});

export const IS_SOLD_POLL_YES = "IS_SOLD_POLL_YES";

export interface IsSoldPollYesAction extends Action {
    readonly type: typeof IS_SOLD_POLL_YES;
    readonly productId: number;
}

export const isSoldPollYes = (productId: number): IsSoldPollYesAction => ({
    type: IS_SOLD_POLL_YES,
    productId,
});

export const IS_SOLD_POLL_NO = "IS_SOLD_POLL_NO";

export interface IsSoldPollNoAction extends Action {
    readonly type: typeof IS_SOLD_POLL_NO;
    readonly productId: number;
}

export const isSoldPollNo = (productId: number): IsSoldPollNoAction => ({
    type: IS_SOLD_POLL_NO,
    productId,
});
